import React, { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { Form, Button, Table } from "react-bootstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Card, CardBody, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./AddInventory.scss";
import { useParams } from "react-router-dom";

// Dummy medicine list
const medicineList = [
  { id: 1, code: "MD-000001", brandName: "Crocin", saltName: "Paracetamol", stock: 50 },
  { id: 2, code: "MD-000002", brandName: "Augmentin", saltName: "Amoxicillin + Clavulanic Acid", stock: 35 },
  { id: 3, code: "MD-000003", brandName: "Metformin", saltName: "Metformin Hydrochloride", stock: 40 },
];

// Map medicines for react-select
const medicineOptions = medicineList.map((m) => ({
  value: m.id,
  label: `${m.brandName} (${m.saltName}) [${m.code}]`,
}));

const UpdateInventory = () => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const [items, setItems] = useState([]);
  // const [note, setNote] = useState("");
  const [date, setDate] = useState("");
  const [errors, setErrors] = useState({});
	const  { invId } = useParams();

  // ✅ Fetch static existing data on mount
  useEffect(() => {
    const existingInventory = {
      reason: "Stock Adjustment",
      date: "2025-08-01",
      // note: "Updated stock after audit",
      items: [
        { ...medicineList[0], quantity: 5 }, // Crocin
        { ...medicineList[1], quantity: 3 }, // Augmentin
      ],
    };

    setReason(existingInventory.reason);
    setDate(existingInventory.date);
    // setNote(existingInventory.note);
    setItems(existingInventory.items);
  }, []);

  // handle medicine selection
  const handleSelectMedicine = (selectedOption) => {
    if (!selectedOption) return;

    const medicine = medicineList.find((m) => m.id === selectedOption.value);
    if (!medicine) return;

    setItems((prev) => {
      const existing = prev.find((item) => item.id === medicine.id);
      if (existing) {
        return prev.map((item) =>
          item.id === medicine.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prev, { ...medicine, quantity: 1 }];
      }
    });
  };

  const updateQuantity = (id, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, Number(value)) }
          : item
      )
    );
  };

  const removeItem = (id) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  };

  // validate form
  const validateForm = () => {
    let newErrors = {};
    if (!reason.trim()) newErrors.reason = "Reason is required";
    if (!date) newErrors.date = "Date is required";
    if (items.length === 0) newErrors.items = "At least one medicine required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Updated inventory:", { reason, items, date });
    alert("Inventory updated successfully!");
  };

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle={t("Update Inventory")}
        parent={t("Dashboard")}
        title={t("Update Inventory")}
      />
      <Col sm="12">
        <Card>
          <CardBody>
            <Form onSubmit={handleUpdate}>
              <div className="row inventory-adjustment">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Adjustment Reason")} *</Form.Label>
                    <Form.Control
                      type="text"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      isInvalid={!!errors.reason}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.reason}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Select Medicine")} *</Form.Label>
                    <Select
                      options={medicineOptions}
                      onChange={handleSelectMedicine}
                      placeholder={t("Search & select a medicine")}
                      isClearable
                    />
                    {errors.items && (
                      <div className="invalid-feedback d-block">
                        {errors.items}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* Table */}
                <div className="col-md-12">
                  {items.length > 0 && (
                    <div className="table-responsive table-wrap inventory-table">
                      <Table size="sm" className="shadow-sm rounded">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{t("Code")}</th>
                            <th>{t("Product Name")}</th>
                            <th>{t("Brand Name")}</th>
                            <th>{t("Stock")}</th>
                            <th>{t("Quantity")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>{item.code}</td>
                              <td>{item.brandName}</td>
                              <td>{item.saltName}</td>
                              <td>
                                <span className="badge bg-warning">
                                  {item.stock}
                                </span>
                              </td>
                              <td>
                                <div className="input-group custom-qty-input table-price-counter-nowrap">
                                  <button
                                    type="button"
                                    className="button-minus icon-shape icon-sm btn-danger"
                                    onClick={() =>
                                      updateQuantity(item.id, item.quantity - 1)
                                    }
                                  >
                                    -
                                  </button>
                                  <input
                                    type="number"
                                    value={item.quantity}
                                    className="quantity-field border-0 incrementor"
                                    onChange={(e) =>
                                      updateQuantity(item.id, e.target.value)
                                    }
                                  />
                                  <button
                                    type="button"
                                    className="button-plus icon-shape icon-sm btn-primary"
                                    onClick={() =>
                                      updateQuantity(item.id, item.quantity + 1)
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="text-end">
                                <button
                                  type="button"
                                  className="btn-danger btn-sm remove-item"
                                  onClick={() => removeItem(item.id)}
                                >
                                  &times;
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>

                {/* Note */}
                {/* <div className="col-md-12">
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Note")}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      placeholder={t("Write your note here")}
                    />
                  </Form.Group>
                </div> */}

                {/* Date */}
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Adjustment Date")} *</Form.Label>
                    <Form.Control
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      isInvalid={!!errors.date}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.date}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2">
                <Button variant="primary" type="submit">
                  {t("Update")}
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setReason("");
                    setItems([]);
                    // setNote("");
                    setDate(new Date().toISOString().split("T")[0]);
                    setErrors({});
                  }}
                >
                  {t("Reset")}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default UpdateInventory;
